import script from "./radioInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./radioInput.vue?vue&type=script&setup=true&lang=ts"

import "./radioInput.vue?vue&type=style&index=0&id=56f5a3b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56f5a3b3"]])

export default __exports__